<template>
  <div class="spikeBox sub-main">
    <div class="warp">
      <!-- <div class="shop">
        <img class="shopLogo" :src="shopLogo" alt="">
        <h2 class="shopName">{{shopName}}</h2>
      </div> -->
      <div class="spikeTit">
        <h3>限时折扣</h3>
        <div class="countdown" v-if="id">
          <div class="countdownTit">本场剩余</div>
          <div class="timeDown">
            <span class="time">{{time | formatHours}}</span>
            <span>:</span>
            <span class="time">{{time | formatMinutes}}</span>
            <span>:</span>
            <span class="time">{{time | formatSeconds}}</span>
          </div>
        </div>
      </div>
      <div v-if="flag">
        <div class='sort' v-if="id==''">
          <div>排序：</div>
          <div class='default' :class="index=='1'?'active':''" @click="defaultSort()">默认</div>
          <div class='price' :class="index=='2'?'active':''" @click="priceSort()">
            价格
            <div class='arr'>
              <div class='up' :class="type==1?'low':''"></div>
              <div class='down' :class="type==2?'high':''"></div>
            </div>
          </div>
          <div class='sales' :class="index=='3'?'active':''" @click="salesSort()">
              销量
              <img v-show="index!=='3'" src='../../../static/image/reduce@2x.png' alt='' />
              <img v-show="index=='3' && volume==1" src='../../../static/image/reduce2@2x.png' alt='' />
              <img v-show="index=='3' && volume==2" src='../../../static/image/reduce1@2x.png' alt='' />
          </div>
        </div>
        <div class="spikeList">
          <div class="item" v-for="item in proList" :key="item.productId">
            <div class="imgBox">
              <img :src="item.image" alt="">
            </div>
            <div class="priceBox">
              <h3>{{item.productName}}</h3>
              <span class="price">折扣价：¥{{item.price}}</span>
              <span class="people">{{item.users}}人付款</span>
              <button @click="toProductDetail(item)">立即抢购</button>
            </div>
          </div>
        </div>
        <el-pagination
          style="margin-bottom:20px;"
          background
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :current-page="page"
          @current-change="changePage"
          :total="total">
        </el-pagination>
      </div>
      <div v-else class="noproduct">
        <img src="../../../static/image/noorder@2x.png" alt="">
        <p class="fs20 font-color-999">该活动没有商品～</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
export default {
  name: 'spitze',
  mixins: [listSearchMixin],
  data () {
    return {
      page: 1,
      pageSize: 12,
      total: 0,
      id: '',
      shopId: '',
      proList: [],
      time: '',
      setTime: null,
      // shopName: '',
      // shopLogo: ''
      type: '',
      volume: '',
      index: '1',
      flag: true
    }
  },
  filters: {
    formatHours: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60))
      if (hours < 10) {
        return '0' + hours
      } else {
        return hours
      }
    },
    formatMinutes: function (value) {
      let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
      if (minutes < 10) {
        return '0' + minutes
      } else {
        return minutes
      }
    },
    formatSeconds: function (value) {
      let seconds = Math.round((value % (1000 * 60)) / 1000)
      if (seconds < 10) {
        return '0' + seconds
      } else {
        return seconds
      }
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId
    }
    this.getDiscount()
  },
  methods: {
    // 倒计时
    countDown () {
      clearInterval(this.setTime)
      this.setTime = setInterval(() => {
        if (this.time < 1000) {
          clearInterval(this.setTime)
          return alert('活动已结束')
        }
        this.time -= 1000
      }, 1000)
    },
    // 跳转到商品详情
    toProductDetail (item) {
      let data = {
        productId: item.productId,
        shopId: item.shopId,
        skuId: item.skuId
      }
      this.$router.push({
        path: '/productDetail',
        query: {
          proData: JSON.stringify(data)
        }
      })
    },
    // 获取店铺首页
    getDiscount () {
      const rLoading = this.openLoading()
      let params = {}
      if (this.id !== '') {
        params = {
          url: api.getDiscount + `?shopId=${this.shopId}&shopDiscountId=${this.id}&page=${this.page}&pageSize=${this.pageSize}`,
          method: 'GET'
        }
      } else {
        params = {
          url: api.getDiscount + `?shopId=${this.shopId}&shopDiscountId=${this.id}&page=${this.page}&pageSize=${this.pageSize}&volume=${this.volume}&type=${this.type}`,
          method: 'GET'
        }
      }
      this.sendReq(params, (res) => {
        if (res.code === '200') {
          this.proList = res.data.page.list
          this.total = res.data.page.total
          this.time = res.data.time
          if (res.data.page.list.length) {
            this.flag = true
          } else {
            this.flag = false
            this.time = 0
          }
          if (this.id !== '' && this.flag) {
            this.countDown()
          }
          // this.shopName = res.data.shopName
          // this.shopLogo = res.data.shopLogo
          rLoading.close()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 翻页
    changePage (val) {
      this.page = val
      this.getDiscount()
    },
    // 默认
    defaultSort () {
      this.index = '1'
      this.page = 1
      this.type = ''
      this.volume = ''
      this.getDiscount()
    },
    // 价格
    priceSort () {
      this.index = '2'
      this.page = 1
      if (this.type === '' || this.type === 2) {
        this.type = 1
      } else {
        this.type = 2
      }
      this.volume = ''
      this.getDiscount()
    },
    // 销量
    salesSort () {
      this.index = '3'
      this.page = 1
      if (this.volume === '' || this.volume === 2) {
        this.volume = 1
      } else {
        this.volume = 2
      }
      this.type = ''
      this.getDiscount()
    }
  }
}
</script>

<style lang="scss" scoped>
.spikeBox {
  margin-top: 100px;
  .shop{
    margin-bottom: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    .shopLogo{
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .shopName{
      font-size: 30px;
      font-weight: bold;
    }
  }
  .spikeTit {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    h3 {
      font-size: 36px;
      color: #333333;
      font-weight: bold;
    }
    .countdown {
      display: flex;
      align-items: center;
      margin-left: 50px;
      .countdownTit {
        font-size: 24px;
        color: #333333;
        font-weight: bold;
      }
      .timeDown{
        margin-left: 10px;
        span{
          display: inline-block;
          text-align: center;
          font-size: 24px;
          height: 40px;
          line-height: 40px;
        }
        .time{
          min-width: 40px;
          background: #000;
          color: #FFFFFF;
        }
      }
    }
  }
  .sort {
    width: 100%;
    height: 63px;
    line-height: 27px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f1f1f1;
    color: #666666;
    margin-bottom: 28px;
    .default {
      margin-left: 20px;
      cursor: pointer;
    }
    .sales {
      margin-right: 20px;
      cursor: pointer;
      img{
        width: 9px;
        height: 16px;
        vertical-align: middle;
      }
    }
    .price {
      display: flex;
      margin: 0 20px;
      cursor: pointer;
      .arr {
        vertical-align: middle;
        width: 12px;
        margin-left: 3px;
        .up {
          width: 0;
          height: 0;
          border: 6px solid transparent;
          border-bottom-color: #999999;
        }
        .down {
          width: 0;
          height: 0;
          border: 6px solid transparent;
          border-top-color: #999999;
          margin-top: 3px;
        }
      }
    }
    .active{
      color: #FF7800;
      .arr{
        .high{
          border-top-color: #FF7800;
        }
        .low{
          border-bottom-color: #FF7800;
        }
      }
    }
  }
  .spikeList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      width: 282px;
      margin:0 40px 65px 0;
      transition: all 0.3s linear;
      .imgBox {
        height: 282px;
        margin-bottom: 25px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .priceBox {
        text-align: center;
        h3 {
          font-size: 16px;
          font-weight: bold;
          color: #333434;
          margin-bottom: 12px;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .price {
          width: 200px;
          font-size: 18px;
          font-weight: bold;
          color: $mainColor;
          display: block;
          padding-bottom: 10px;
          border-bottom: 2px solid #f3f3f3;
          margin: 0 auto 13px auto;
        }
        .people {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          display: block;
          margin-bottom: 16px;
        }
        button {
          width: 120px;
          height: 34px;
          background: linear-gradient(247deg, #F71622, #FE6F52);
          border: 1px solid #EC4B42;
          border-radius: 4px;
          color: #FFFFFF;
          cursor: pointer;
        }
      }
    }
    .item:hover{
      box-shadow:0 0 20px #cccccc;
    }
  }
  .noproduct{
    width: 100%;
    text-align: center;
    min-height: 500px;
    img{
      margin-top: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/promotions/spitze.vue